import { render, staticRenderFns } from "./CommentPreview.vue?vue&type=template&id=18876613&scoped=true&"
import script from "./CommentPreview.vue?vue&type=script&lang=js&"
export * from "./CommentPreview.vue?vue&type=script&lang=js&"
import style0 from "./CommentPreview.vue?vue&type=style&index=0&id=18876613&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18876613",
  null
  
)

export default component.exports